<template>
  <el-popover width="750px" trigger="click" @show="showChangeLogs">
    <el-table :data="valueChangeLogs" stripe max-height="600px" size="mini">
      <el-table-column
          label="Thuộc tính "
          min-width="150px"
          property="property"
          show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span class="padding-0 margin-0">
            <span class="font-size__small">
              {{ scope.row.propertyLabel }}
            </span>
          </span>
        </template>
      </el-table-column>
      <el-table-column
          label="Từ: "
          min-width="300px"
          show-overflow-tooltip
          property="oldValue"
      >
        <template slot-scope="scope">
          <span class="padding-0 margin-0">
            <span
                class="font-weight__bold font-size__small"
                style="white-space: pre-line; word-break: break-word;"
            >{{ scope.row.oldValue }}</span
            >
          </span>
        </template>
      </el-table-column>

      <el-table-column
          label="Đến: "
          min-width="300px"
          show-overflow-tooltip
          property="oldValue"
      >
        <template slot-scope="scope">
          <span class="padding-0 margin-0">
            <span
                class="font-weight__bold font-size__small"
                style="white-space: pre-line; word-break: break-word;"
            >{{ scope.row.newValue }}</span
            >
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-tooltip slot="reference" content="Nhấn để xem chi tiết" placement="top">
      <i
          class="font-size__small fas fa-info-circle color__yellow clickable"
          style="margin-left: 5px"
      ></i>
    </el-tooltip>
  </el-popover>
</template>

<script>
export default {
  name: "value-change-logs-detail",
  props: ["valueChangeLogs"],
  methods: {
    showChangeLogs() {
      this.$emit("showChangeLogs")
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/value-change-logs-detail.vue